import '@/scss/pages/math.scss'

import header from '../layout/header'
import { cookiesPopUp } from '../common/cookies'
import fullForm from '../section/home/full-form'
import initExitPopup from '../section/exit-popup'
import initStrip from '../section/blog/strip'
import { setTrackExitPopupCloseEvent } from '../common/button-track'

document.addEventListener('DOMContentLoaded', function () {
  header()
  cookiesPopUp()
  fullForm()
  initExitPopup()
  initStrip()
  setTrackExitPopupCloseEvent()
})
